import script from "./TableLike.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableLike.vue?vue&type=script&lang=ts&setup=true"

import "./TableLike.vue?vue&type=style&index=0&id=6a75bf3d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a75bf3d"]])

export default __exports__